 <form [formGroup]="form">
    @if (organisations()?.length) {
        <ion-item>
          <ion-select label="Organization" interface="popover" placeholder="{{'Select organization' | translate}}" formControlName="organisation" (ionChange)="onOrganisationSelected($event)">
            @for (o of organisations(); track $index;) {
              <ion-select-option [value]="o._id">{{ o.organisationAbbreviation }}</ion-select-option>
            }
          </ion-select>
        </ion-item>

        @if(organisationPolicy?.length && authService.authUserSignal()?.role?.value > 399){
            <ion-item>
                <ion-select label="Policy" interface="popover" placeholder="{{'Select policy' | translate}}" formControlName="policy" (ionChange)="onPolicySelected($event)">
                  @for (p of organisationPolicy; track $index;) {
                    <ion-select-option [value]="p._id">{{ p.name }}</ion-select-option>
                  }
                </ion-select>
            </ion-item>
        }
    } 
</form>